import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginIntraFnoHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import NoDataContainer from "../../../../generic/noDataContainer";

export interface IMarginIntraFnoTableDskProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginIntraFnoTableDsk: React.FC<IMarginIntraFnoTableDskProps> = props => {
	return (
		<div className="mrgn_ifno_tbl table">
			<ul className="hdr_row">
				<li className="tr">
					<div className="td ScripName">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="ScripName"
								onSort={props.sortProps.onSort}
								colName={marginIntraFnoHeading.scripName}
							/>
						</span>
					</div>
					<div className="td Marketlot">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="Marketlot"
								onSort={props.sortProps.onSort}
								colName={marginIntraFnoHeading.marketlot}
							/>
						</span>
					</div>
					<div className="td TotalMarginLongPos right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="TotalMarginLongPos"
								onSort={props.sortProps.onSort}
								colName={marginIntraFnoHeading.totalMarginLongPos}
							/>
						</span>
					</div>
					<div className="td TotalMarginPerLot right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="TotalMarginPerLot"
								onSort={props.sortProps.onSort}
								colName={marginIntraFnoHeading.totalMarginPerLot}
							/>
						</span>
					</div>
					<div className="td MISMargin right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="MISMargin"
								onSort={props.sortProps.onSort}
								colName={marginIntraFnoHeading.misMargin}
							/>
						</span>
					</div>
					<div className="td MISMarginperLot right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="MISMarginperLot"
								onSort={props.sortProps.onSort}
								colName={marginIntraFnoHeading.misMarginperLot}
							/>
						</span>
					</div>
				</li>
			</ul>

			{props.tableData.length ? (
				<ul className="mrgn_scrl_cont data_rows">
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<React.Fragment key={index}>
							<li className="tr">
								<div className="td ScripName robotoM">
									<span dangerouslySetInnerHTML={{ __html: row.ScripName }}></span>
								</div>
								<div className="td Marketlot">{row.Marketlot}</div>
								<div className="td TotalMarginLongPos right">{row.TotalMarginLongPos}</div>
								<div className="td TotalMarginPerLot right">{toINR(row.TotalMarginPerLot)}</div>
								<div className="td MISMargin right">{toINR(row.MISMargin)}</div>
								<div className="td MISMarginperLot right">{toINR(row.MISMarginperLot)}</div>
							</li>
						</React.Fragment>
					))}
				</ul>
			) : (
				<NoDataContainer txtHeading="No results found" />
			)}
		</div>
	);
};

export default MarginIntraFnoTableDsk;
